/** @file English catalog part of area E3 (W3-03): the Timeline panel strings. */

/** The `timeline` panel block (spread into `panels`); `animations` is the Animations panel's. */
export const timelineEn = {
  timeline: {
    title: 'Timeline', views: 'Timeline views', dopesheet: 'Dopesheet', toolbar: 'Playback', rows: 'Timeline rows', keys: 'Dopesheet keys',
    play: 'Play', pause: 'Pause', first: 'First frame', prev: 'Previous frame', next: 'Next frame', last: 'Last frame', frame: 'Frame',
    key: 'Key', autoKey: 'Auto-key', clearLoop: 'Loop {a}–{b} ×', noAnimation: 'Pick an animation in the Animations panel.',
    expand: 'Show the channels of {name}', collapse: 'Hide the channels of {name}', drawOrder: 'Draw order', events: 'Events',
    channels: {
      rotation: 'Rotation', x: 'Translate X', y: 'Translate Y', scaleX: 'Scale X', scaleY: 'Scale Y', shearX: 'Shear X', shearY: 'Shear Y',
      inherit: 'Inherit', attachment: 'Attachment', rgb: 'Color', alpha: 'Alpha', dark: 'Dark color', ikMix: 'IK mix',
      ikSoftness: 'IK softness', ikBend: 'IK bend', ikStretch: 'IK stretch', ikCompress: 'IK compress', deform: 'Deform', drawOrder: 'Draw order',
    },
  },
  animations: {
    title: 'Animations', list: 'Animations', empty: 'No animations yet.', newName: 'New animation name',
    open: 'Open {name} in the timeline', rename: 'Name of {name}', frames: 'Frames', duplicate: 'Duplicate', remove: 'Delete',
    mix: { title: 'Mix preview', from: 'From', to: 'To', seconds: 'Mix (s)', play: 'Preview', stop: 'Stop', save: 'Save as default' },
  },
} as const;
